import { useEffect } from 'react'
import { replaceBlocked } from './app-badge.js'

/**
 * Keeps the PWA badge equal to the needs-you count (lib/needs-you.ts `needsYouItemIds`).
 * `undefined` while the Inbox is still loading (the badge keeps its last value).
 */
export function useAppBadge(ids: readonly string[] | undefined) {
  const key = (ids ?? []).join('\n')
  // biome-ignore lint/correctness/useExhaustiveDependencies: `key` stands for `ids`
  useEffect(() => {
    if (ids) void replaceBlocked(ids)
  }, [key, !!ids])
}
